import React from 'react';
import styled from 'styled-components';
import StringFormatter from '../utils/StringFormatter';
import TextInfoTooltip from './TextInfoTooltip';
import { PopupDirections } from './Tooltip';
export var LabelFontFamily;
(function (LabelFontFamily) {
    LabelFontFamily["FONT_FAMILY_REGULAR"] = "FONT_FAMILY_REGULAR";
    LabelFontFamily["FONT_FAMILY_MEDIUM"] = "FONT_FAMILY_MEDIUM";
    LabelFontFamily["FONT_FAMILY_DEMI"] = "FONT_FAMILY_DEMI";
})(LabelFontFamily || (LabelFontFamily = {}));
const Label = ({ text, parameters, className, tooltipText, tooltipParameters, tooltipPopupDirection = PopupDirections.RIGHT, OverlayContainer, ...rest }) => {
    // TODO ADD I18N
    const outputText = StringFormatter(text, parameters);
    const tooltip = tooltipText && (React.createElement(TextInfoTooltip, { text: tooltipText, parameters: tooltipParameters, popupDirection: tooltipPopupDirection, OverlayContainer: OverlayContainer }));
    return React.createElement(LabelContent, { className: className, ...rest },
        React.createElement(OutputTextWrapper, { hasTooltip: tooltipText !== undefined }, outputText),
        tooltip);
};
const LabelContent = styled('span') `

    display: flex;
    display: ${props => props.isHidden && 'none'};
    align-items: center;

    font-family: ${props => props.theme.fonts.medium};
    font-family: ${props => props.fontFamily && props.fontFamily === LabelFontFamily.FONT_FAMILY_REGULAR && props.theme.fonts.regular};
    font-family: ${props => props.fontFamily && props.fontFamily === LabelFontFamily.FONT_FAMILY_MEDIUM && props.theme.fonts.medium};
    font-family: ${props => props.fontFamily && props.fontFamily === LabelFontFamily.FONT_FAMILY_DEMI && props.theme.fonts.demi};

    font-size: ${props => props.fontSize ?? '14px'};
`;
const OutputTextWrapper = styled('span') `
    align-self: center;

    ${props => props.hasTooltip ? 'margin-right: 10px;' : ''}
`;
export default Label;
//# sourceMappingURL=Label.js.map